<div class="centralize-all">
  <div class="user-form-container-web">
    <div class="user-form-container">
      <div class="user-form">
        <div class="user-form-left">
          <p class="paragrafo">Dados de cadastro</p>
          <form class="manage-user-form" [formGroup]="userForm">
            <div class="field-help">
              <mat-form-field appearance="outline">
                <mat-label>Perfil de acesso*</mat-label>
                <mat-select formControlName="profile">
                  <mat-option
                    [value]="profile"
                    *ngFor="let profile of profiles"
                  >
                    {{ profile.name }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="userForm.get('profile')?.hasError('required')"
                  >Informe o perfil de acesso</mat-error
                >
              </mat-form-field>
              <button mat-icon-button (click)="handleHelp()">
                <img src="./../../../assets/icons/Group_278.svg" />
              </button>
            </div>

            <mat-form-field
              appearance="outline"
              class="input-form"
              *ngIf="showStudentElements"
            >
              <mat-label>RA*</mat-label>
              <input matInput formControlName="ra" />
              <mat-error *ngIf="userForm.get('ra')?.hasError('required')"
                >Informe o RA</mat-error
              >
            </mat-form-field>

            <div
              class="field-help"
              *ngIf="isResponsible && hasActiveSoftIntegration"
            >
              <mat-form-field appearance="outline" class="input-form">
                <mat-label>Id do Activesoft</mat-label>
                <span
                  matPrefix
                  *ngIf="showPrefix() || idActivesoftFocus"
                  class="prefix"
                  >{{ this.prefixIdActivesoft }}</span
                >
                <input
                  matInput
                  formControlName="idActivesoft"
                  (focusin)="idActivesoftFocus = true"
                  (focusout)="idActivesoftFocus = false"
                />
              </mat-form-field>
              <button mat-icon-button (click)="handleHelpIdActivesoft()">
                <img src="./../../../assets/icons/Group_278.svg" />
              </button>
            </div>

            <mat-form-field
              appearance="outline"
              class="input-form"
              *ngIf="showBasicFields"
            >
              <mat-label>Nome completo*</mat-label>
              <input matInput formControlName="name" />
              <mat-error *ngIf="userForm.get('name')?.hasError('required')"
                >Informe o nome completo</mat-error
              >
            </mat-form-field>

            <mat-form-field
              appearance="outline"
              class="input-form"
              *ngIf="showBasicFields"
            >
              <mat-label>Telefone (Opcional)</mat-label>
              <input matInput formControlName="phone" appPhoneFormat />
            </mat-form-field>

            <mat-form-field
              appearance="outline"
              class="input-form"
              *ngIf="showBasicFields"
            >
              <mat-label>E-mail*</mat-label>
              <input matInput type="email" formControlName="email" />
              <mat-error *ngIf="userForm.get('email')?.hasError('required')"
                >Informe o seu e-mail</mat-error
              >
              <mat-error *ngIf="userForm.get('email')?.hasError('emailExists')"
                >Este e-mail já está em uso</mat-error
              >
            </mat-form-field>

            <mat-form-field
              appearance="outline"
              class="input-form"
              *ngIf="showBasicFields"
            >
              <mat-label>Senha*</mat-label>
              <input
                matInput
                data-recording-sensitive
                [type]="hide ? 'password' : 'text'"
                formControlName="password"
                autocomplete="password"
              />
              <button
                mat-icon-button
                matSuffix
                type="button"
                (click)="hide = !hide"
                [attr.aria-pressed]="hide"
                [attr.aria-label]="'Mostrar senha'"
              >
                <span>
                  <img
                    src="{{
                      hide
                        ? '../../../assets/icons/Group 1458.svg'
                        : '../../../assets/icons/Group 1457.svg'
                    }}"
                  />
                </span>
              </button>
              <mat-error *ngIf="userForm.get('password')?.hasError('required')"
                >Informe a senha</mat-error
              >
              <mat-error *ngIf="userForm.get('password')?.hasError('minlength')"
                >{{ invalidMinPasswordErrorMessage }}
              </mat-error>
            </mat-form-field>
          </form>

          <mat-card class="mat-card-classrooms" *ngIf="showStudentElements">
            <label class="label-card">Vincule turmas para este aluno</label>
            <app-button-link-year-classrooms
              [classroomYear]="textYear"
              [idsClassrooms]="checkedIdsClassrooms"
              [text]="selectedClassrooms"
              (outputData)="updateCheckedClassroom($event)"
            >
            </app-button-link-year-classrooms>
          </mat-card>
        </div>
        <div
          class="manage-user-form-container user-form-right"
          *ngIf="showBasicFields"
        >
          <p class="paragrafo">Informe os responsáveis deste aluno</p>
          <app-attention-alert
            [message]="alertMessage"
          >
          </app-attention-alert>

          <div class="add-user-button-container">
            <div class="add-user-button-text-grey-regular-16px">
              <p>Adicionar novo {{ addMessageUserProfile }}</p>
            </div>

            <div class="add-new-user-input">
              <img
                class="search-icon"
                src="../../../../../../assets/icons/lupa.svg"
              />
              <input
                #textInput
                class="add-new-user-name"
                type="text"
                placeholder="Pesquise por nome"
                matInput
                [matAutocomplete]="auto"
                [(ngModel)]="selecteduser"
                (input)="handleSearchUser()"
              />
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option
                  (onSelectionChange)="addUserTo(option)"
                  (click)="textInput.blur()"
                  *ngFor="let option of users | async"
                >
                  <div class="user-searched-item">
                    <div>
                      <img class="user-photo" src="{{ option.photo }}" />
                    </div>
                    <div class="user-searched-item-name-email">
                      <div>
                        <label class="user-searched-name"
                          >{{ option.firstName }} {{ option.lastName }}</label
                        >
                      </div>
                      <div>
                        <label class="user-searched-email">{{
                          option.email
                        }}</label>
                      </div>
                    </div>
                  </div>
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="user-add-card" *ngIf="addUsersTo.length > 0">
              <app-user-added-card
                *ngFor="let item of addUsersTo"
                [email]="item.email"
                [fullName]="item.firstName + ' ' + item.lastName"
                [imageURL]="item.photo"
                (removeClicked)="removeUserFromList(item)"
                (click)="changeUser(item.id)"
              >
              </app-user-added-card>
            </div>
          </div>
        </div>

        <div *ngIf="showBasicFields && canEdit">
          <div class="flex-btn">
            <button
              mat-raised-button
              [disabled]="userForm.invalid"
              [className]="
                userForm.invalid
                  ? 'btn-clear mat-raised-button mat-button-base btn-clear-disabled'
                  : 'btn-clear mat-raised-button mat-button-base'
              "
              (click)="clearInputFields()"
            >
              Limpar
            </button>
            <button
              mat-raised-button
              [disabled]="userForm.invalid || !userForm.dirty"
              [className]="
                userForm.invalid || !userForm.dirty
                  ? 'mat-focus-indicator btn-salvar mat-raised-button mat-button-base submit-disabled'
                  : 'mat-focus-indicator btn-salvar mat-raised-button mat-button-base'
              "
              (click)="saveUser()"
            >
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
